module.exports = __webpack_public_path__ + "img/arrecredi_btoptext_img.aa4d5da0.webp";